/**
 * Maps `meta.section` to its screen (plan 6.C–6.H). Payments only exists for paid events
 * (a free event asked for `?section=payments` gets Quick setup).
 */

import React from "react";
import { useBuilder } from "../state/builderContext";
import { SECTIONS } from "../state/constants";
import { isPaid } from "../state/selectors";
import QuickSetup from "./quick/QuickSetup";
import AvailabilitySection from "./availability/AvailabilitySection";
import HostsSection from "./hosts/HostsSection";
import InviteeSection from "./invitee/InviteeSection";
import NotificationsSection from "./notifications/NotificationsSection";
import PaymentsSection from "./payments/PaymentsSection";

const SectionRouter = () => {
  const { state } = useBuilder();
  const section = state.meta.section;
  switch (section) {
    case SECTIONS.AVAILABILITY:
      return <AvailabilitySection />;
    case SECTIONS.HOSTS:
      return <HostsSection />;
    case SECTIONS.INVITEE:
      return <InviteeSection />;
    case SECTIONS.NOTIFICATIONS:
      return <NotificationsSection />;
    case SECTIONS.PAYMENTS:
      return isPaid(state) ? <PaymentsSection /> : <QuickSetup />;
    case SECTIONS.QUICK:
    default:
      return <QuickSetup />;
  }
};

export default SectionRouter;
